module.exports = __webpack_public_path__ + "static/img/card1.1e43db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card1.png
// module id = eotO
// module chunks = 2